import { useQuery } from '@tanstack/react-query';

import { fetchFileUrl } from 'hb-react/frontoffice/apps/MediaCenter/utils/mediaCenterUrls';
import { MEDIA_CENTER_QUERY_KEYS } from 'hb-react/frontoffice/apps/MediaCenter/utils/queryUtils';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const useFile = ({ fileUuid, enabled, params = {} }) =>
  useQuery({
    queryKey: [MEDIA_CENTER_QUERY_KEYS.file, fileUuid],
    queryFn: () => getFile(fileUuid, params),
    enabled,
  });

const getFile = (fileUuid, params = {}) =>
  axios.get(fetchFileUrl(fileUuid), { params }).then((res) => res.data);
